// extracted by mini-css-extract-plugin
module.exports = {"confirmation-status-panel":"ConfirmationStatusPanel_confirmation-status-panel__1zX31"};